import { useState, useEffect } from "react";

import useUniversalStore from "store/universalStore";
import { stringSort, numSort, getAllTagsFromAccounts } from "utils";

const Filters = ({ setFilteredAccounts }) => {
  const { accounts } = useUniversalStore((state) => state);
  const [hideClosed, setHideClosed] = useState(true);
  const [sort, setSort] = useState({ col: "name", desc: false });
  const [search, setSearch] = useState("");
  const [selectedTag, setSelectedTag] = useState(null);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (accounts) setTags(getAllTagsFromAccounts(accounts));
  }, [accounts]);

  useEffect(() => {
    setFilteredAccounts(filterAccounts(accounts));
  }, [accounts, sort, hideClosed, search, selectedTag]);

  const handleSearchInput = (e) => {
    setSearch(e.target.value);
  }

  const clearSearch = () => setSearch("");

  const filterAccounts = (originalAccounts) => {
    if (!originalAccounts) return [];

    let _accounts = originalAccounts;
    if (search.trim()) {
      const searchTerm = search.toLowerCase();
      _accounts = _accounts.filter(
        (account) =>
          account.get("name").toLowerCase().includes(searchTerm) ||
          account.get("phone")?.includes(search)
      );
    }

    if (selectedTag) {
      _accounts = _accounts.filter((account) =>
        account.get("tag")?.includes(selectedTag)
      );
    }

    _accounts =
      sort.col === "balance"
        ? numSort(_accounts, sort.desc, sort.col)
        : stringSort(_accounts, sort.desc, sort.col);

    _accounts = hideClosed
      ? _accounts.filter((account) => !account.get("cancelled"))
      : _accounts;

    return _accounts;
  };

  const TagDropdown = () => {
    return (
      <div className="dropdown mx-2">
        <i
          className={`fs-4 bi bi-tag${selectedTag ? "-fill text-app" : ""}`}
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        ></i>
        <ul className="dropdown-menu">
          <li
            className="dropdown-item d-flex"
            role="button"
            onClick={() => setSelectedTag(null)}
          >
            <span className="me-auto">All Tags</span>
            {!selectedTag && <i className="bi bi-check2"></i>}
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          {tags.map((tag, index) => (
            <li
              key={index}
              className="dropdown-item d-flex"
              role="button"
              onClick={() => setSelectedTag(tag)}
            >
              <span className="me-auto">{tag}</span>
              {selectedTag === tag && <i className="bi bi-check2"></i>}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const SortDropdown = () => {
    return (
      <div className="dropdown pt-1 px-2">
        <i
          className="bi bi-arrow-down-up dropdown-toggle fs-5"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        />
        <ul className="dropdown-menu">
          <li
            className="dropdown-item cursor"
            onClick={(e) => setSort({ col: "name", desc: !sort.desc })}
          >
            <span className="me-auto">Name</span>
            <span className={sort.col === "name" ? "" : "invisible"}>
              <i
                className={`bi ${
                  sort.desc ? "bi-sort-alpha-down" : "bi bi-sort-alpha-up"
                }`}
              ></i>
            </span>
          </li>
          <li
            className="dropdown-item cursor"
            onClick={(e) => setSort({ col: "balance", desc: !sort.desc })}
          >
            <span className="me-auto">Balance</span>
            <span className={sort.col === "balance" ? "" : "invisible"}>
              <i
                className={`bi ${
                  sort.desc
                    ? "bi-sort-numeric-up-alt"
                    : "bi bi-sort-numeric-down"
                }`}
              ></i>
            </span>
          </li>
        </ul>
      </div>
    );
  };

  return (
    <div className="row align-items-baseline border shadow px-0 mx-0 py-1">
      <div className="col-9 col-md-9">
        <div className="input-group my-3">
          <span className="input-group-text">
            <i className="bi bi-search"></i>
          </span>
          <input
            type="text"
            className="form-control py-0 col-8 col-md-8 accountsearch text-start border border-bottom"
            placeholder="Search accounts"
            value={search}
            onChange={handleSearchInput}
          />
          {search && (
            <button
              className="btn btn-outline-secondary"
              onClick={clearSearch}
              type="button"
            >
              <i className="bi bi-x"></i>
            </button>
          )}
        </div>
      </div>
      <div className="col-3 col-md-3 d-flex justify-content-end">
        <SortDropdown />
        <i className={`fs-4 mx-2 bi  ${hideClosed
                        ? "bi-filter-circle-fill text-app": "bi-filter"}`}
          role="button"
          onClick={(e) => setHideClosed(!hideClosed)}></i>
        <TagDropdown />
      </div>
    </div>
  );
};

export default Filters;
